import { render, staticRenderFns } from "./ProductPicker.vue?vue&type=template&id=2a4b9407&scoped=true"
import script from "./ProductPicker.vue?vue&type=script&lang=js"
export * from "./ProductPicker.vue?vue&type=script&lang=js"
import style0 from "./ProductPicker.vue?vue&type=style&index=0&id=2a4b9407&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4b9407",
  null
  
)

export default component.exports